module.exports = __webpack_public_path__ + "img/c08_unitvimana_Normal_ua.ee12528a.webp";